/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_Developer_Ic_HintInputs */

const cs_projects_developer_ic_hint = /** @type {(inputs: Projects_Developer_Ic_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Musí být už registrované u Seznamu (nelze založit přes API).`)
};

const en_projects_developer_ic_hint = /** @type {(inputs: Projects_Developer_Ic_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Must already be registered at Seznam (not creatable via API).`)
};

/**
* | output |
* | --- |
* | "Must already be registered at Seznam (not creatable via API)." |
*
* @param {Projects_Developer_Ic_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const projects_developer_ic_hint = /** @type {((inputs?: Projects_Developer_Ic_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Developer_Ic_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_projects_developer_ic_hint(inputs)
	return cs_projects_developer_ic_hint(inputs)
});